<template>
  <simplebar class="nav--overflow" data-simplebar-auto-hide="false">
    <ul class="nav--list">
      <router-link to="/" active-class="active" exact class="nav--list-link">
        <li @click="callToggleMenu" class="nav--list-item text__bold">
          <font-awesome-icon icon="home" size="lg" class="icon" />
          <span>Home</span>
        </li>
      </router-link>
      <router-link to="/information" active-class="active" class="nav--list-link">
        <li @click="callToggleMenu" class="nav--list-item text__bold">
          <font-awesome-icon icon="info" size="lg" class="icon" />
          <span>Info</span>
        </li>
      </router-link>
      <router-link to="/loan-officers" active-class="active" class="nav--list-link">
        <li @click="callToggleMenu" class="nav--list-item text__bold">
          <font-awesome-icon icon="user-tie" size="lg" class="icon" />
          <span>Lenders</span>
        </li>
      </router-link>
      <li class="nav--list-item pointer" @click="setAdminToggled">
        <font-awesome-icon v-if="!adminToggled" icon="chevron-down" size="lg" class="icon" />
        <font-awesome-icon v-else icon="chevron-up" size="lg" class="icon" />
        <span class="text__bold">Admin</span>
      </li>
      <transition name="nav--sub">
        <div v-if="adminToggled" class="sub-menu">
          <router-link
            v-if="getUser.isAdmin"
            to="/users"
            active-class="active"
            exact
            class="nav--list-link"
          >
            <li @click="callToggleMenu" class="nav--list-item text__bold">
              <font-awesome-icon icon="user-friends" size="lg" class="icon" />
              <span>Users</span>
            </li>
          </router-link>
          <router-link to="/licenses" active-class="active" class="nav--list-link">
            <li @click="callToggleMenu" class="nav--list-item text__bold">
              <font-awesome-icon icon="address-card" size="lg" class="icon" />
              <span>Licenses</span>
            </li>
          </router-link>
          <router-link to="/services" active-class="active" class="nav--list-link">
            <li @click="callToggleMenu" class="nav--list-item text__bold">
              <font-awesome-icon icon="cog" size="lg" class="icon" />
              <span>Services</span>
            </li>
          </router-link>
        </div>
      </transition>
      <li class="nav--list-item pointer" @click="setRequestsToggled">
        <font-awesome-icon v-if="!requestsToggled" icon="chevron-down" size="lg" class="icon" />
        <font-awesome-icon v-else icon="chevron-up" size="lg" class="icon" />
        <span class="text__bold">Requests</span>
      </li>
      <transition name="nav--sub">
        <div v-if="requestsToggled" class="sub-menu">
          <router-link
            v-for="type in getRequestTypes"
            :to="`/${type.url}`"
            :key="type.url"
            active-class="active"
            class="nav--list-link"
          >
            <li @click="callToggleMenu" class="nav--list-item text__bold">
              <font-awesome-icon :icon="type.icon" size="lg" class="icon" />
              <span>{{ type.name }}</span>
            </li>
          </router-link>
        </div>
      </transition>
    </ul>
  </simplebar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      adminToggled: false,
      requestsToggled: false
    };
  },
  computed: {
    ...mapGetters(["getRequestTypes", "getUser"]),
    adminClass() {
      return this.adminToggled ? "sub-active" : null;
    },
    requestsClass() {
      return this.requestsToggled ? "sub-active" : null;
    }
  },
  methods: {
    ...mapActions(["toggleMenu"]),
    callToggleMenu() {
      if (window.innerWidth < 992) {
        this.toggleMenu();
      } else {
        return;
      }
    },
    setAdminToggled() {
      return (this.adminToggled = !this.adminToggled);
    },
    setRequestsToggled() {
      return (this.requestsToggled = !this.requestsToggled);
    }
  }
};
</script>

<style scoped lang="scss">
</style>